export default __webpack_public_path__ + "static/media/gcjz.56eaec9a.svg";